import { apiBaseUrl } from "./config"
import { SCENARII } from "./constant/url-segment"
import { getBaseHeader } from "./utils"
import { genericFetch } from "./common-service"
import * as Model from "../../model"
import { createScenarioAccountThemeCommentRequestBody } from "./factory"

function getScenariiBaseUrl(): string {
    return `${apiBaseUrl}/${SCENARII}/la`
}

function getScenarioBaseUrl(): string {
    return `${apiBaseUrl}/${SCENARII}`
}

export function getBudgetAnnexeData(laId: string, scenarioId: string): Promise<any> {
    const url = `${apiBaseUrl}/scenarios/calculate/full/localAuthority/${laId}/scenario/${scenarioId}`
    const init = {
        headers: getBaseHeader(true),
    }

    return genericFetch(url, init)
}

export function findCurrentValidatedScenario(
    localAuthority: Model.LocalAuthority
): Promise<Model.Scenario> {
    const url = `${getScenariiBaseUrl()}/${localAuthority.id}/validated`
    const init: RequestInit = { headers: getBaseHeader() }
    return genericFetch<Model.Scenario>(url, init)
}

export function findScenarii(
    localAuthority: Model.LocalAuthority,
    signal?: AbortSignal
): Promise<Model.Scenario[]> {
    const url = `${getScenariiBaseUrl()}/${localAuthority.id}`
    const init: RequestInit = { headers: getBaseHeader(), signal }
    return genericFetch<Model.Scenario[]>(url, init)
}

export function updateAccountThemeComment(
    scenario: Model.Scenario,
    account: Model.Account,
    theme: Model.Theme,
    comment: string,
    receipts: boolean
): Promise<Model.ScenarioAccountTheme> {
    const url = `${getScenarioBaseUrl()}/${scenario.id}/account/theme/comment`
    const body = JSON.stringify(createScenarioAccountThemeCommentRequestBody(account, theme, comment, receipts))
    const init: RequestInit = {
        body,
        headers: {
            ...getBaseHeader(),
            "Content-Type": "application/json"
        },
        method: "PUT"
    }
    return genericFetch<Model.ScenarioAccountTheme>(url, init)
}

export function deleteAccountThemeComment(
    scenario: Model.Scenario,
    account: Model.Account,
    theme: Model.Theme,
    comment: string,
    receipts: boolean
): Promise<Model.ScenarioAccountTheme> {
    const url = `${getScenarioBaseUrl()}/${scenario.id}/account/theme/comment`
    const body = JSON.stringify(createScenarioAccountThemeCommentRequestBody(account, theme, comment, receipts))
    const init: RequestInit = {
        body,
        headers: {
            ...getBaseHeader(),
            "Content-Type": "application/json"
        },
        method: "DELETE"
    }
    return genericFetch<Model.ScenarioAccountTheme>(url, init)
}

export function deleteAccountValue(
    scenario: Model.Scenario,
    account: Model.Account,
    receipts: boolean
): Promise<Model.Scenario> {
    const url = `${apiBaseUrl}/${SCENARII}/${scenario.id}/account/value`
    const body = JSON.stringify({ account: account.id, receipts })
    const headers: HeadersInit = {
        ...getBaseHeader(),
        'Content-Type': 'application/json'
    }
    const init: RequestInit = { body, headers, method: "DELETE" }

    return genericFetch<Model.Scenario>(url, init)
}

export function deleteAccountComment(
    scenario: Model.Scenario,
    account: Model.Account,
    receipts: boolean
): Promise<Model.Scenario> {
    const url = `${apiBaseUrl}/${SCENARII}/${scenario.id}/account/comment`
    const body = JSON.stringify({ account: account.id, receipts })
    const headers: HeadersInit = {
        ...getBaseHeader(),
        'Content-Type': 'application/json'
    }
    const init: RequestInit = { body, headers, method: "DELETE" }

    return genericFetch<Model.Scenario>(url, init)
}

export function deleteChapterValue(
    scenario: Model.Scenario,
    chapter: Model.Chapter,
    receipts: boolean
): Promise<Model.Scenario> {
    const url = `${apiBaseUrl}/${SCENARII}/${scenario.id}/chapter/value`
    const body = JSON.stringify({ chapter: chapter.id, receipts })
    const headers: HeadersInit = {
        ...getBaseHeader(),
        'Content-Type': 'application/json'
    }
    const init: RequestInit = { body, headers, method: "DELETE" }

    return genericFetch<Model.Scenario>(url, init)
}

export function deleteValue(
    scenario: Model.Scenario,
    year: number,
    account: Model.Account,
    receipts: boolean
): Promise<Model.Scenario> {
    const url = `${apiBaseUrl}/${SCENARII}/${scenario.id}/value`
    const body = JSON.stringify({ account: account.id, receipts, year })
    const headers: HeadersInit = {
        ...getBaseHeader(),
        'Content-Type': 'application/json'
    }
    const init: RequestInit = { body, headers, method: "DELETE" }

    return genericFetch<Model.Scenario>(url, init)
}

export function updateAccountValue(
    scenario: Model.Scenario,
    account: Model.Account,
    amount: number,
    receipts: boolean
): Promise<Model.Scenario> {
    const url = `${apiBaseUrl}/${SCENARII}/${scenario.id}/account/value`
    const body = JSON.stringify({ account: account.id, amount, receipts })
    const headers: HeadersInit = {
        ...getBaseHeader(),
        'Content-Type': 'application/json'
    }
    const init: RequestInit = { body, headers, method: "PUT" }

    return genericFetch<Model.Scenario>(url, init)
}

export function updateAccountComment(
    scenario: Model.Scenario,
    account: Model.Account,
    comment: string,
    receipts: boolean
): Promise<Model.Scenario> {
    const url = `${apiBaseUrl}/${SCENARII}/${scenario.id}/account/comment`
    const body = JSON.stringify({ account: account.id, comment, receipts })
    const headers: HeadersInit = {
        ...getBaseHeader(),
        'Content-Type': 'application/json'
    }
    const init: RequestInit = { body, headers, method: "PUT" }

    return genericFetch<Model.Scenario>(url, init)
}

export function updateChapterValue(
    scenario: Model.Scenario,
    chapter: Model.Chapter,
    amount: number,
    receipts: boolean
): Promise<Model.Scenario> {
    const url = `${apiBaseUrl}/${SCENARII}/${scenario.id}/chapter/value`
    const body = JSON.stringify({ chapter: chapter.id, amount, receipts })
    const headers: HeadersInit = {
        ...getBaseHeader(),
        'Content-Type': 'application/json'
    }
    const init: RequestInit = { body, headers, method: "PUT" }

    return genericFetch<Model.Scenario>(url, init)
}

export function updatePreviousResult(
    scenario: Model.Scenario,
    year: number,
    amount: number
): Promise<Model.Scenario> {
    const url = `${apiBaseUrl}/${SCENARII}/${scenario.id}/previous_result`
    const body = JSON.stringify({ year, amount })
    const headers: HeadersInit = {
        ...getBaseHeader(),
        'Content-Type': 'application/json'
    }
    const init: RequestInit = { body, headers, method: "PUT" }

    return genericFetch<Model.Scenario>(url, init)
}

export function updateScenario(
    scenarioId: number,
    scenario: Partial<Model.Scenario>
): Promise<Model.Scenario> {
    const url = `${apiBaseUrl}/${SCENARII}/${scenarioId}`
    const body = JSON.stringify({ scenario })
    const headers: HeadersInit = {
        ...getBaseHeader(),
        'Content-Type': 'application/json'
    }
    const init: RequestInit = { body, headers, method: "PUT" }

    return genericFetch<Model.Scenario>(url, init)
}

export function updateValue(
    scenario: Model.Scenario,
    year: number,
    account: Model.Account,
    amount: number,
    percentile: boolean,
    receipts: boolean
): Promise<Model.Scenario> {
    const url = `${apiBaseUrl}/${SCENARII}/${scenario.id}/value`
    const body = JSON.stringify({
        account: account.id,
        amount,
        percentile,
        receipts,
        year
    })
    const headers: HeadersInit = {
        ...getBaseHeader(),
        'Content-Type': 'application/json'
    }
    const init: RequestInit = { body, headers, method: "PUT" }

    return genericFetch<Model.Scenario>(url, init)
}



// WEBPACK FOOTER //
// ./src/service/sfp/scenarii-service.ts